<template>
  <div>
    <div class="rda-legend-status" style="margin-bottom: 0px">
      <strong>Legenda:</strong><br /><span
        class="tags"
        style="margin-right: 0px; background-color: #b23066"
        >EE</span
      >
      <strong>:</strong> Conteúdo em estudo |
      <span class="tags" style="margin-right: 0px">A</span
      ><strong>:</strong> Conteúdo aprendido |
      <span class="tags" style="margin-right: 0px; background-color: #ffbb00"
        >AN</span
      ><strong>:</strong> Conteúdo ainda não aprendido
      <span v-if="allItems"
        >|<br />
        <span
          class="tags"
          style="margin-right: 0px; padding: 1px 5px; background-color: #a9a9a9"
          >*</span
        ><strong>:</strong> Conteúdo supostamente aprendido em outro
        estabelecimento de ensino |
        <span class="tags" style="margin-right: 0px; background-color: #a9a9a9"
          >#</span
        >
        <strong>:</strong>
        Dispensa de conteúdo curricular
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "RDALegendComponent",
  props: {
    allItems: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showAll: false,
    };
  },
  methods: {
    toggleShowAll() {
      this.showAll = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.rda-legend-status {
  padding-top: 20 px;
  align-items: flex-start;
  p {
    font-size: 16px;
    line-height: 1.2;
  }
}

.tags {
  &.warning {
    background-color: var(--orange);
  }
  padding: 2px 3px;
}

.cols {
  .tags {
    min-width: 40px;
  }
}
</style>
